import { useMemo } from 'react';
import type { CountryItem } from '@digiseg-labs/api-client';
import type { SelectedAudience } from '../components/audience-builder/types';
import { buildReachAnalysis, buildSankeyData } from '../utils/audienceBuilder';

type Params = {
  selectedAudiences: SelectedAudience[];
  selectedCountry: CountryItem | undefined;
  locale?: string;
};

export const useAudienceBuilderData = ({ selectedAudiences, selectedCountry, locale }: Params) => {
  const resolvedLocale = useMemo(
    () => (locale ?? (typeof navigator !== 'undefined' ? navigator.language : undefined)),
    [locale],
  );

  const analysis = useMemo(
    () => buildReachAnalysis(selectedAudiences, selectedCountry),
    [selectedAudiences, selectedCountry],
  );

  const sankeyData = useMemo(
    () => buildSankeyData(selectedAudiences, selectedCountry, resolvedLocale),
    [selectedAudiences, selectedCountry, resolvedLocale],
  );

  return { analysis, sankeyData };
};
